import React, { useEffect, useState } from 'react';
import theme from './SellerSidebar.module.scss';
import { faStars } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';
import {
    Button,
    ExternalLinkButton,
    LoadingIndicator,
    MarkdownDisplay,
    Modal,
    ModalBody,
    ModalFooter,
} from '@ygtechnologies/bygr-frontend-component-library';
import { Button as RubusUiButton } from '@ygtechnologies/rubus-ui';
import { useCurrentCulture } from '@/utils/hooks';

const reports = [
    {
        lang: 'en',
        markdownImport: () => import('./report_markdowns/report_en.md?raw'),
    },
    {
        lang: 'nb',
        markdownImport: () => import('./report_markdowns/report_no.md?raw'),
    },
    {
        lang: 'sv',
        markdownImport: () => import('./report_markdowns/report_sv.md?raw'),
    },
    {
        lang: 'de',
        markdownImport: () => import('./report_markdowns/report_de.md?raw'),
    },
];

export const getReport = (lang: string) => {
    const imp = reports.find((x) => x.lang === lang)?.markdownImport();
    if (!imp) throw Error('Cultures not supported');
    return imp;
};

export interface SellerSidebarReportsPreviewButtonProps {
    isOpen: boolean;
    toggle: () => void;
}
export const SellerSidebarReportsPreview: React.FC<SellerSidebarReportsPreviewButtonProps> = ({ isOpen, toggle }) => {
    const [cultureInfo] = useCurrentCulture();

    const [md, setMd] = useState<null | string>(null);
    useEffect(() => {
        if (cultureInfo?.languageCode) {
            async function loadMd() {
                const importMd = (await getReport(cultureInfo!.languageCode)).default;
                setMd(importMd);
            }
            loadMd();
        }
    }, [cultureInfo?.languageCode]);
    return (
        <Modal size="lg" toggle={toggle} isOpen={isOpen}>
            <ModalBody>{!md ? <LoadingIndicator /> : <MarkdownDisplay markdown={md} className={theme.centerImages} />}</ModalBody>
            <ModalFooter>
                <Button onClick={toggle} color="tertiary">
                    <Trans>Close</Trans>
                </Button>
                <ExternalLinkButton href="mailto:sales@rubustech.io" color="primary">
                    <Trans>Contact sales</Trans>
                </ExternalLinkButton>
            </ModalFooter>
        </Modal>
    );
};
